import { _ as _defineProperty } from '../../unsorted/defineProperty.js';
import { _ as _toConsumableArray } from '../../unsorted/toConsumableArray.js';
import { serializeChildren } from '../../utils/componentHelpers.js';
import { c as createFastContext } from '../../utils/createFastContext.js';

var CLOSE_DRAWER = "closeDrawer";
var OPEN_DRAWER = "openDrawer";
var UPDATE_DRAWER_PROPS = "updateDrawerProps";
var CLOSE_MODAL = "closeModal";
var OPEN_MODAL = "openModal";
var UPDATE_MODAL_PROPS = "updateModalProps";
var CLOSE_POPOVER = "closePopover";
var OPEN_POPOVER = "openPopover";
var UPDATE_POPOVER_PROPS = "updatePopoverProps";
var CLOSE_TOAST = "closeToast";
var OPEN_TOAST = "openToast";
var UPDATE_TOAST_PROPS = "updateToastProps";

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var initialState = {
  modalList: [],
  popoverList: [],
  drawerList: [],
  toastList: []
};
var overlayReducer = function overlayReducer(state, action) {
  // @TODO: perhaps split up this reducer somehow, its pretty damn long
  switch (action.type) {
    /**
     *
     * MODAL OVERLAY ACTIONS ......
     *
     */
    case UPDATE_MODAL_PROPS:
      {
        var currentIndex = -1;
        state.modalList.forEach(function (modal, i) {
          if (modal.id === action.payload.id) {
            currentIndex = i;
          }
        });
        if (currentIndex >= 0) {
          // @TODO: this is a pretty shitty way to check if content has
          // changed, and could have pretty regrettable performance
          // but it's the only option we can think of right now...
          var newContentSerialised = serializeChildren(action.payload);
          var oldContentSerialised = serializeChildren(state.modalList[currentIndex]);
          var contentHasChanged = newContentSerialised !== oldContentSerialised;
          if (contentHasChanged) {
            var updatedList = _toConsumableArray(state.modalList);
            updatedList[currentIndex] = action.payload;
            return _objectSpread(_objectSpread({}, state), {}, {
              modalList: updatedList
            });
          }
          return state;
        }
        return state;
      }
    case OPEN_MODAL:
      {
        var doesntAlreadyExist = !state.modalList.find(function (modal) {
          return modal.id === action.payload.id;
        });
        return _objectSpread(_objectSpread({}, state), {}, {
          modalList: [].concat(_toConsumableArray(state.modalList), _toConsumableArray(doesntAlreadyExist ? [action.payload] : []))
        });
      }
    case CLOSE_MODAL:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          modalList: state.modalList.filter(function (modal) {
            return modal.id !== action.payload.id;
          })
        });
      }
    /**
     *
     * POPOVER OVERLAY ACTIONS ......
     *
     */
    case UPDATE_POPOVER_PROPS:
      {
        var _currentIndex = -1;
        state.popoverList.forEach(function (popover, i) {
          if (popover.id === action.payload.id) {
            _currentIndex = i;
          }
        });
        if (_currentIndex >= 0) {
          var _newContentSerialised = serializeChildren(action.payload);
          var _oldContentSerialised = serializeChildren(state.popoverList[_currentIndex]);
          var _contentHasChanged = _newContentSerialised !== _oldContentSerialised;
          if (_contentHasChanged) {
            var _updatedList = _toConsumableArray(state.popoverList);
            _updatedList[_currentIndex] = action.payload;
            return _objectSpread(_objectSpread({}, state), {}, {
              popoverList: _updatedList
            });
          }
          return state;
        }
        return state;
      }
    case OPEN_POPOVER:
      {
        // @NOTE: allow for React.StrictMode where double renders happen
        // (which causes multiple copies of popover to be stored)
        var _doesntAlreadyExist = !state.popoverList.find(function (popover) {
          return popover.id === action.payload.id;
        });
        return _objectSpread(_objectSpread({}, state), {}, {
          popoverList: [].concat(_toConsumableArray(state.popoverList), _toConsumableArray(_doesntAlreadyExist ? [action.payload] : []))
        });
      }
    case CLOSE_POPOVER:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          popoverList: state.popoverList.filter(function (popover) {
            return popover.id !== action.payload.id;
          })
        });
      }

    /**
     *
     * BOTTOM SHEET OVERLAY ACTIONS ......
     *
     */
    case UPDATE_DRAWER_PROPS:
      {
        var _currentIndex2 = -1;
        state.drawerList.forEach(function (drawer, i) {
          if (drawer.id === action.payload.id) {
            _currentIndex2 = i;
          }
        });
        if (_currentIndex2 >= 0) {
          var _newContentSerialised2 = serializeChildren(action.payload);
          var _oldContentSerialised2 = serializeChildren(state.drawerList[_currentIndex2]);
          var _contentHasChanged2 = _newContentSerialised2 !== _oldContentSerialised2;
          if (_contentHasChanged2) {
            var _updatedList2 = _toConsumableArray(state.drawerList);
            _updatedList2[_currentIndex2] = action.payload;
            return _objectSpread(_objectSpread({}, state), {}, {
              drawerList: _updatedList2
            });
          }
          return state;
        }
        return state;
      }
    case OPEN_DRAWER:
      {
        var _doesntAlreadyExist2 = !state.drawerList.find(function (drawer) {
          return drawer.id === action.payload.id;
        });
        return _objectSpread(_objectSpread({}, state), {}, {
          drawerList: [].concat(_toConsumableArray(state.drawerList), _toConsumableArray(_doesntAlreadyExist2 ? [action.payload] : []))
        });
      }
    case CLOSE_DRAWER:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          drawerList: state.drawerList.filter(function (drawer) {
            return drawer.id !== action.payload.id;
          })
        });
      }

    /**
     *
     * TOAST OVERLAY ACTIONS ......
     *
     */
    case UPDATE_TOAST_PROPS:
      {
        var _currentIndex3 = -1;
        state.toastList.forEach(function (drawer, i) {
          if (drawer.id === action.payload.id) {
            _currentIndex3 = i;
          }
        });
        if (_currentIndex3 >= 0) {
          var _newContentSerialised3 = serializeChildren(action.payload);
          var _oldContentSerialised3 = serializeChildren(state.toastList[_currentIndex3]);
          var _contentHasChanged3 = _newContentSerialised3 !== _oldContentSerialised3;
          if (_contentHasChanged3) {
            var _updatedList3 = _toConsumableArray(state.toastList);
            _updatedList3[_currentIndex3] = action.payload;
            return _objectSpread(_objectSpread({}, state), {}, {
              toastList: _updatedList3
            });
          }
          return state;
        }
        return state;
      }
    case OPEN_TOAST:
      {
        var _doesntAlreadyExist3 = !state.toastList.find(function (toast) {
          return toast.id === action.payload.id;
        });
        return _objectSpread(_objectSpread({}, state), {}, {
          toastList: [].concat(_toConsumableArray(state.toastList), _toConsumableArray(_doesntAlreadyExist3 ? [action.payload] : []))
        });
      }
    case CLOSE_TOAST:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          toastList: state.toastList.filter(function (toast) {
            return toast.id !== action.payload.id;
          })
        });
      }
    default:
      {
        console.error("Unknown reducer action:", action);
        return state;
      }
  }
};
var _createFastContext = createFastContext(initialState, overlayReducer),
  BiomeOverlaysProvider = _createFastContext.Provider,
  useOverlaysStore = _createFastContext.useStore;
BiomeOverlaysProvider.displayName = "BiomeOverlaysProvider";

export { BiomeOverlaysProvider as B, CLOSE_DRAWER as C, OPEN_DRAWER as O, UPDATE_DRAWER_PROPS as U, CLOSE_MODAL as a, OPEN_MODAL as b, UPDATE_MODAL_PROPS as c, CLOSE_POPOVER as d, OPEN_POPOVER as e, UPDATE_POPOVER_PROPS as f, CLOSE_TOAST as g, OPEN_TOAST as h, UPDATE_TOAST_PROPS as i, initialState as j, useOverlaysStore as u };
//# sourceMappingURL=overlaysContext.js.map
